import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import Landing from "./pages/Landing";
import StorePreview from "./pages/StorePreview";

// Admin imports
import AdminLogin from "./pages/admin/AdminLogin";
import AdminGuard from "./components/admin/AdminGuard";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Stores from "./pages/admin/Stores";
import StoreDetail from "./pages/admin/StoreDetail";
import Emails from "./pages/admin/Emails";
import Prompts from "./pages/admin/Prompts";
import PromptDetail from "./pages/admin/PromptDetail";
import Categories from "./pages/admin/Categories";
import Products from "./pages/admin/Products";
import ProductDetail from "./pages/admin/ProductDetail";
import Generations from "./pages/admin/Generations";
import GenerationDetail from "./pages/admin/GenerationDetail";
import Settings from "./pages/admin/Settings";
import SourceCategories from "./pages/admin/SourceCategories";

import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/store/:storeId" element={<StorePreview />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route element={<AdminGuard />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/stores" element={<Stores />} />
                <Route path="/admin/stores/:id" element={<StoreDetail />} />
                <Route path="/admin/emails" element={<Emails />} />
                <Route path="/admin/prompts" element={<Prompts />} />
                <Route path="/admin/prompts/:id" element={<PromptDetail />} />
                <Route path="/admin/categories" element={<Categories />} />
                <Route path="/admin/products" element={<Products />} />
                <Route path="/admin/products/:id" element={<ProductDetail />} />
                <Route path="/admin/generations" element={<Generations />} />
                <Route path="/admin/generations/:id" element={<GenerationDetail />} />
                <Route path="/admin/settings" element={<Settings />} />
                <Route path="/admin/source-categories" element={<SourceCategories />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
